import React from 'react'
import * as S from './styles'
import { ReactComponent as SearchIcon } from '../../../../assets/icons/search-old.svg'

const NoResultsFound = ({ title, subTitle }) => {
  return <S.Container>
    <S.IconWrapper>
      <SearchIcon />
    </S.IconWrapper>
    <S.TextWrapper>
      <S.TitleNoNotification>{title}</S.TitleNoNotification>
      <S.SubtitleNoNotification>{subTitle}</S.SubtitleNoNotification>
    </S.TextWrapper>
  </S.Container>
}

export default NoResultsFound
